import {
  DatumMapConfig,
  DEFAULT_DATUM_MAP_CONFIG,
} from '@datum-group/datum-map/lib';

const TOP_PANEL_HEIGHT = 100;
const RIGHT_PANEL_WIDTH = 100;
const BOTTOM_PANEL_HEIGHT = 100;

const MAP_EXTENT_PADDING = 50;
const LEFT_SIDEBAR_WIDTH = 414;

export const DATUM_MAP_CONFIG: DatumMapConfig = {
  ...DEFAULT_DATUM_MAP_CONFIG,
  map: {
    layer: {
      cluster: {
        animated: {
          animation: {
            animationDuration: 500,
          },
          autoZoom: {
            padding: [
              TOP_PANEL_HEIGHT + MAP_EXTENT_PADDING,
              RIGHT_PANEL_WIDTH + MAP_EXTENT_PADDING,
              BOTTOM_PANEL_HEIGHT + MAP_EXTENT_PADDING,
              LEFT_SIDEBAR_WIDTH + MAP_EXTENT_PADDING,
            ],
            duration: 500,
            maxZoom: 18,
          },
          links: { color: '#547bfb80', width: 1 },
          select: {
            pointRadius: 20,
            animate: true,
            animationDuration: 500,
          },
        },
      },
    },
  },
};
